import { render } from "./designHboxPrint.vue?vue&type=template&id=ed321f6c"
import script from "./designHboxPrint.vue?vue&type=script&lang=js"
export * from "./designHboxPrint.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__